import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import ImageService from "../../api/imageService";

export const getImages =
    createAsyncThunk(`${SliceNames.IMAGE}/getImages`,
        async (_, thunkAPI) => {
            try {
                const res = await ImageService.fetchImages()

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createImage =
    createAsyncThunk(`${SliceNames.IMAGE}/createImage`,
        async (imageToAdd: File, thunkAPI) => {
            try {
                const formData: FormData = new FormData()
                formData.append('image_to_add', imageToAdd);
                const res = await ImageService.createImage(formData)
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteImage =
    createAsyncThunk(`${SliceNames.IMAGE}/deleteImage`,
        async (req: { imageId: string, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                await ImageService.deleteImage(req.imageId)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return req.imageId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })